import React, { Component, Fragment } from "react";
import moment from "moment";
import StatusIndicator from "../../../statusIndicator/StatusIndicator";
import TableDropdown from "./TableDriopDown/TableDropDown";
import LocoOutOfUse from "images/ReVAMP/outOfUse.png";
import LocoCompliant from "images/ReVAMP/compliant.png";
import LocoNonCompliant from "images/ReVAMP/nonCompliant.png";
import DailyImg from "images/ReVAMP/dailyDueG.png";
import DailyImgPending from "images/ReVAMP/dailyDue.png";
import momentTz from "moment-timezone";
import ReportSelectorTableCustomizedForDashboard from "../../../../CommonUI/ReportSelectorTable/ReportSelectorTableCustomizedForDashboard";
import { languageService } from "../../../../Language/language.service";
import { versionInfo } from "../../../MainPage/VersionInfo";
class DashboardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      flatTableData: [],
    };
    this.groupData = this.groupData.bind(this);
    this.flatGroupedData = this.flatGroupedData.bind(this);
  }

  componentDidMount() {
    if (this.props.data) {
      let x = this.groupData(this.props.data);
      let flatted = this.flatGroupedData(x);
      this.setState({
        tableData: [...x],
        flatTableData: [...flatted],
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      let x = this.groupData(this.props.data);
      let flatted = this.flatGroupedData(x);
      this.setState({
        tableData: [...x],
        flatTableData: [...flatted],
      });
    }
  }

  groupData = (data) => {
    let mylist = [];
    let processed = new Map();

    data.forEach((e) => {
      let muId = e && e.muId;
      if (muId) {
        if (!processed.has(muId)) {
          let x = data.filter((element) => element && element.muId === muId);
          mylist.push({
            SorM: muId,
            list: x,
          });
          processed.set(muId, true);
        }
      } else {
        let singleGroup = mylist.find((group) => group.SorM === "single");
        if (!singleGroup) {
          singleGroup = { SorM: "single", list: [] };
          mylist.push(singleGroup);
        }
        singleGroup.list.push(e);
      }
    });
    return mylist;
  };

  flatGroupedData(groupedData) {
    let flatData = groupedData.flatMap((group) => group.list.map((item) => ({ ...item, SorM: group.SorM })));
    return flatData;
  }

  render() {
    return (
      <Fragment>
        <ReportSelectorTableCustomizedForDashboard
          cols={columns()}
          data={[...this.state.flatTableData]}
          thStyle={{
            background: "#20232e",
            fontSize: "12px",
            position: "relative",
            borderRadius: "5px",
            color: "#d9e4ec",
          }}
        />
      </Fragment>
    );
  }
}

export default DashboardTable;

const columns = () =>
  [
    {
      text: "Head",
      id: "SorM",
      accessor: (data) => (data && data.SorM === "single" ? "" : data && data.SorM),
      width: "8px",
    },
    {
      text: "Name",
      id: "name",
      width: "9px",
    },
    {
      text: "Status",
      id: "status",
      width: "9px",
      accessor: (data) => {
        const { nonCompliant } = data && data.assetStates ? data.assetStates : {};
        if (!nonCompliant) {
          return (
            <span style={{ color: "#ff8a00", fontWeight: 600, fontSize: "16px" }}>
              <span>
                <img style={{ width: "24px" }} src={LocoCompliant} alt={"out of use"} />
              </span>
            </span>
          ); //compliant
        } else if (nonCompliant) {
          return (
            <span style={{ color: "#ff8a00", fontWeight: 600, fontSize: "16px" }}>
              <span>
                <img style={{ width: "24px" }} src={LocoNonCompliant} alt={"out of use"} />
              </span>
            </span>
          ); // non complaint
        }
      },
    },
    !versionInfo.isDailyDisabled() && {
      text: "Daily",
      id: "assetStates",
      accessor: (data) => {
        const dailyDueDate = data && data.assetStates && data.assetStates.dailyDue ? data.assetStates.dailyDue : null;

        const startOfDay = momentTz.tz("US/Eastern").startOf("day").format();
        const endOfDay = momentTz.tz("US/Eastern").endOf("day").format();
        const isSameDay = dailyDueDate >= startOfDay && dailyDueDate <= endOfDay ? true : false;

        return (
          <span style={{ color: "#ff8a00", fontWeight: 600, fontSize: "16px" }}>
            <span>
              <img style={{ width: "24px" }} src={isSameDay ? DailyImg : DailyImgPending} alt={"daily"} />
            </span>
          </span>
        );
      },
      width: "7px",
    },
    {
      text: "Out of Use",
      id: "outOfUse",
      accessor: (data) => {
        const isOutOfUse = data && data.assetStates && data.assetStates.outOfUse;
        const outOfUseDays = data && data.outOfUseCredit && data.outOfUseCredit.outOfUseDays;

        return (
          <span
            style={{
              position: "relative",
              display: "inline-block",
              padding: "4px",
            }}
          >
            {isOutOfUse ? (
              <React.Fragment>
                <img style={{ width: "24px" }} src={LocoOutOfUse} alt="out of use" />
                <span
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "0",
                    transform: "translateX(50%)",
                    borderRadius: "8px",
                    fontSize: "12px",
                    padding: "2px 6px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  {outOfUseDays !== 0 && outOfUseDays}
                </span>
              </React.Fragment>
            ) : null}
          </span>
        );
      },
      width: "7px",
    },
    {
      text: "Next Inspection",
      id: "DueInspec",
      accessor: (data) => {
        if (!data.DueInspec.nextExpiryDate) {
          return "";
        }
        return moment(data && data.DueInspec && data.DueInspec.nextExpiryDate).format("MM/DD/YYYY");
      },
      width: "10px",
    },
    {
      text: "Engine Hours",
      id: "engineHour",
      accessor: (data) => <span>{data && data.assetStates && data.assetStates.engineHour}</span>,
      width: "9px",
    },
    {
      text: "Out of Use Credit",
      id: "outOfUseCredit",
      accessor: (data) => {
        if (data.outOfUseCredit && data.outOfUseCredit.credit >= 30)
          return (
            <div>
              <span> {data.outOfUseCredit.credit}</span>
            </div>
          );
      },
      width: "11px",
    },
    {
      text: "Actions",
      id: "actions",
      accessor: (data) => {
        const options = [
          { value: "", label: languageService("Reports"), header: true },
          { value: "blueCard", label: languageService("Blue card") },
          { value: "maintenanceRecord", label: languageService("Repair History") },
          { value: "nonCompliant", label: languageService("Non Compliant") },
          { value: "reviewMaintenance", label: languageService("Compliance Report") },
          { value: "outOfUseHistory", label: languageService("Out of use history") },
          { value: "", label: languageService("Actions"), header: true },
          { value: "outOfUseApply", label: languageService("Apply out of use"), disabled: true },
        ];
        if (
          data &&
          data.outOfUseCredit &&
          data.outOfUseCredit.status &&
          data.outOfUseCredit.status === "Available" &&
          data.outOfUseCredit.credit &&
          data.outOfUseCredit.credit >= 30
        ) {
          options.map((e) => {
            if (e.value === "outOfUseApply") {
              e.disabled = false;
            }
          });
        }

        const handleOptionClick = (object) => {
          if (object.value === "outOfUseApply") {
            data && data.outOfUseClick({ ...data });
          }
          if (object.value === "outOfUseHistory") {
            data && data.viewHistory({ ...data });
          }
          if (object.value === "maintenanceRecord") {
            data && data.maintenanceHistoryClick({ ...data });
          }
          data && data.navigate(object, { ...data });
        };
        return (
          <Fragment>
            <TableDropdown options={options} onOptionClick={handleOptionClick} />
          </Fragment>
        );
      },
    },
  ].filter(Boolean);



// WEBPACK FOOTER //
// ./src/components/Dashboard/ReVAMP_Dashboard/DashboardTable/DashboardTable.jsx